import React from "react";

export function WhatnotLogoIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...rest}
    >
      <path
        d="M16 0C22.05 0 26.36 0.72 29.05 3.46C31.56 6.02 32 10.62 32 16C32 21.38 31.56 25.98 29.05 28.54C26.36 31.28 22.05 32 16 32C9.95 32 5.64 31.28 2.95 28.54C0.44 25.98 0 21.38 0 16C0 10.62 0.44 6.02 2.95 3.46C5.64 0.72 9.95 0 16 0Z"
        fill="#FFE500"
        vectorEffect={vectorEffect}
      />
      <path
        d="M5.2 13.55C5.2 10.4 7.4 8.15 10.18 8.15C12.24 8.15 13.6 9.26 14.29 11.25C14.55 12.01 14.79 12.82 15.15 12.82C15.5 12.82 15.74 12.01 16 11.25C16.69 9.26 18.06 8.15 20.11 8.15C22.9 8.15 25.1 10.4 25.1 13.55C25.1 15.1 24.57 16.55 23.62 18.05L21.38 21.58C20.47 23.01 19.4 23.65 18.17 23.65C16.98 23.65 16.07 22.99 15.4 21.7L13.77 18.56C13.55 18.13 13.15 18.26 13.29 18.73L13.69 20.18C14.23 22.12 13.29 23.65 11.59 23.65C10.36 23.65 9.29 23.01 8.38 21.58L6.68 18.9C5.65 17.28 5.2 15.31 5.2 13.55Z"
        fill="#272326"
        vectorEffect={vectorEffect}
      />
    </svg>
  );
}
